
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdfGenerator/digitalCard",
      function () {
        return require("private-next-pages/pdfGenerator/digitalCard/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pdfGenerator/digitalCard"])
      });
    }
  